import { Link } from "react-router-dom";
import BackButton from "../../../../sharedComponents/backButton/BackButton";
import "./Areas.css";
import PrimaryButton from "../../../../sharedComponents/primaryButton/PrimaryButton";
import AreaList from "./areaList/AreaList";


function Areas(){
    return(
        <>
            <div className="areas-container">
                <Link to={"/home/settings/"}><BackButton /></Link>
                <div className="areas-header">
                    <h3>Bereiche zuteilen</h3>
                    <Link to={"creation"}>
                        <PrimaryButton text="Neuen Bereich hinzufügen"/>
                    </Link>
                </div>
                <AreaList />
            </div>
        </>
    )
}

export default Areas;